// extracted by mini-css-extract-plugin
module.exports = {"root":"_3QCQa1naKP-l-ZSzyJViL8","center":"_21HShLxOUsCMkOvrAoPo5D"};